import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';

type Headers = {
  Authorization?: string;
  [name: string]: string | null | undefined | number;
};

type Config = AxiosRequestConfig & {
  headers?: Headers;
  params?: Record<string, string | number>;
};

export class ApiService {
  private config = {
    headers: {},
    params: {},
  } as Config;

  private axios = axios.create({
    baseURL: `${process.env.REACT_APP_API_SERVER}/en/public/api/1.0.0/`,
    paramsSerializer: (data: object) => qs.stringify(data, { arrayFormat: 'brackets' }),
  });

  public setToken(token: string | null) {
    const { Authorization, ...rest } = this.config.headers;

    this.config.headers = {
      ...rest,
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  public get<T>(uri: string, params = {}) {
    return this.axios
      .get<T>(uri, this.mergeConfigs(params))
      .then((response) => response.data);
  }

  public post<T>(uri: string, data: unknown, params = {}) {
    return this.axios
      .post<T>(uri, data, this.mergeConfigs(params))
      .then((response) => response.data);
  }

  public put<T>(uri: string, data: unknown, params = {}) {
    return this.axios
      .put<T>(uri, data, this.mergeConfigs(params))
      .then((response) => response.data);
  }

  public delete<T = void>(uri: string, params = {}) {
    return this.axios
      .delete(uri, this.mergeConfigs(params))
      .then((response) => response.data as T);
  }

  private mergeConfigs(params: Config['params']) {
    return {
      ...this.config,
      params: { ...this.config.params, ...params },
    };
  }
}

export default new ApiService();
